import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSkipMembership,setForceLogin,setHasMembershipContext,setMemberOnlyTicketsDeleted } from '@/actions/ui';
import { wrappedFetch } from '@h/fetch';
import { useTranslation } from '@c/Translations';
import { fetchReservation } from '../actions/reservation';
import { getEventPriceLevels } from 'checkout/actions/event';
import { getEventSeriesChildListing } from '../views/series/actions/event-series';
import { membershipLogoutAndRefresh } from '../helpers/membershipLogoutAndRefresh';

const MemberAuthButtons = () => {
  const dispatch = useDispatch();

  const isMembershipAvailable = !!useSelector(state => state.ui?.uiConfig?.membershipFormConfig?.membership_available);
  if (!isMembershipAvailable) {
    return null;
  }
  const isMembershipSkipped = !!useSelector(state => state.ui?.skipMembership);
  const isMemberLoggedIn = useSelector(state => state.ui.hasMembershipContext);
  const isSkipLogin = useSelector(state => state.ui?.uiConfig?.membershipFormConfig?.skip_login);
  const token = useSelector(state => state.reservation?.token);
  const secret = useSelector(state => state.reservation?.secret);
  const selectedChildEvent = useSelector(state => state.event?.childEvent?.event);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const isRecurring = useSelector(state => state.ui.isRecurring);

  const login = () => {
    dispatch(setSkipMembership(false));
    dispatch(setForceLogin(true));
  };
  const proceedRefresh = async () => {
    dispatch(fetchReservation(token, secret));
    dispatch(setSkipMembership(false));
    dispatch(setHasMembershipContext(false));

    if (isRecurring && selectedChildEvent) {
      dispatch(getEventSeriesChildListing(selectedChildEvent.event_id));
    } else {
      dispatch(getEventPriceLevels());
    }
  };

  const logout = async() => {
    if (loading) {
      return;
    }
  
    setLoading(true);
    try {
      const res = await wrappedFetch(`/api/memberships/${token}`, {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'reservation-secret': secret,
        },
      });
      const data = await res.json();
      if (data.deleted) {
        dispatch(setMemberOnlyTicketsDeleted(true));
      }else{
        await dispatch(membershipLogoutAndRefresh(token, secret, isRecurring, selectedChildEvent));
      }
    } catch (err) {
      console.error('Logout flow error:', err);
    } finally {
      setLoading(false);
    }
  };

  let linkText = null;
  let onClickHandler = null;
  
  if (isMemberLoggedIn) {
    linkText = t('checkout__member_logout');
    onClickHandler = logout;
  } else if (isMembershipSkipped || isSkipLogin) {
    linkText = t('checkout__member_login');
    onClickHandler = login;
  } else {
    return null;
  } 
  
  return (
    <div style={{ marginTop: '16px' }}>
      <a
        href="#"
        style={{ textDecoration: 'none' }}
        onClick={(e) => {
          e.preventDefault();
          if (!loading) {
            onClickHandler();
          }
        }}
      >
        {loading ? <><span> <span className='loader'></span> {linkText}</span></> : linkText}
      </a>
    </div>
  );
};

export default MemberAuthButtons;
